export default __webpack_public_path__ + "static/media/joe.b630b8f7.png";